<template>
  <div>
    <div class="title">
      <el-row style="margin: 0 0 10px 0 ;">
        <el-col :lg="22">
          <div class="waiTitel">
            <div class="green01"></div>
            <div class="title"
                 style="margin: 0 0 0 3px; font-family: SourceHanSansCN-Bold; font-size: 18px;">
              订单列表
            </div>
          </div>
        </el-col>
        <el-col :lg="2">
          <el-button @click="filterOrder()" size="small" icon="el-icon-refresh"
                     style="margin-left: 10px;background-color: #ffffff; color: #000000; float: right;">刷新
          </el-button>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-row :gutter="10">
        <el-col :lg="17" class="grid-content">
          <div class="">
            <div class="topTitle">
              <div class="green02"></div>
              <div class="topTitleSmall">数据概览</div>
            </div>
          </div>
          <el-row class="main-content">
            <el-col :lg="6">
              <div class="main-title">
                销售总额
              </div>
              <div class="main-number">
                ￥{{ orderData[0].total }}
              </div>
            </el-col>
            <el-col :lg="6">
              <div class="main-title">
                微信销售额
              </div>
              <div class="main-number">
                ￥{{ orderData[0].wechatTotal }}
              </div>
            </el-col>
            <el-col :lg="6">
              <div class="main-title">
                项目订单数
              </div>
              <div class="main-number">
                {{ orderData[0].userCount }}
                <!-- 剪发+烫染+美团 -->
              </div>
            </el-col>
            <el-col :lg="6">
              <div class="main-title">
                套餐单数
              </div>
              <div class="main-number">
                {{ orderData[0].memberCount }}
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :lg="6" :offset="1" class="grid-content">
          <div class="bg-purple">
            <div class="topTitle">
              <div class="green02"></div>
              <div class="topTitleSmall">营销销售概览</div>
            </div>
            <div class="topRight">
              <el-row>
                <el-col :lg="11" :offset="1">
                  <div class="f01">权益销售额</div>
                </el-col>
                <el-col :lg="11" :pull="1">
                  <div class="f02" style="float: right;">
                    ￥{{ orderData[0].memberDetailTotal }}
                  </div>
                </el-col>
              </el-row>
              <div style="width: 280px;height: 1px;background-color:#EFEFEF ;"></div>
              <el-row>
                <!-- 								<el-col :lg="11" :offset="1">
                  <div class="f01">会员销售额</div>
                </el-col>
                <el-col :lg="11" :pull="1">
                  <div class="f02" style="float: right;">
                    ￥{{orderData[0].memberTotal}}
                  </div>
                </el-col> -->
                <el-col :lg="11" :offset="1">
                  <div class="f01">美团销售额</div>
                </el-col>
                <el-col :lg="11" :pull="1">
                  <div class="f02" style="float: right;">
                    ￥{{ orderData[0].meituanTotal ? orderData[0].meituanTotal : 0 }}
                  </div>
                </el-col>
              </el-row>
              <div style="width: 280px;height: 1px;background-color:#EFEFEF ;"></div>
              <el-row>
                <el-col :lg="11" :offset="1">
                  <!-- <div class="f01">Halo销售额</div> -->
                  <div class="f01">次卡销售额</div>
                </el-col>
                <el-col :lg="11" :pull="1">
                  <div class="f02" style="float: right;">
                    <!-- ￥{{orderData[0].haloTotal}} -->
                    ￥{{ orderData[0].timeCardTotal }}
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="tableCol">
      <p>
        <el-select v-model="query.type" style="width: 150px;margin-right: 20px;" size="small">
          <el-option v-for="item in keys" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input type="text" style="width: 250px;margin-right: 20px;" size="small" v-model="query.text"
                  @keydown.enter.native="filterOrder()">
        </el-input>
        <span style="margin-left: 10px; margin-right: 10px;">门店</span>
        <el-select v-model="query.storeId" @change="filterOrder()" clearable filterable
                   style="width: 150px; margin-right: 20px;" size="small">
          <el-option-group label="营业门店">
            <el-option v-for="item in stores" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-option-group>
          <el-option-group label="结业门店">
            <el-option v-for="item in storesEnd" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-option-group>
        </el-select>
        状态
        <el-select v-model="query.orderStatus" collapse-tags @change="filterOrder()"
                   style="width: 150px;margin-left: 10px;margin-right: 20px;" size="small">
          <el-option v-for="item in orderStateList" :key="item.value" :label="item.label" :value="item.value"
                     :disabled="query.orderStatus[0] == 100 && item.value != 100">
          </el-option>
        </el-select>
        类型
        <el-select v-model="query.orderType" @change="filterOrder()"
                   style="width: 150px;margin-left: 10px;margin-right: 20px;" size="small">
          <el-option v-for="item in orderTypeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        筛选项目
        <el-select v-model="query.haircutType" @change="filterOrder()" style="width: 150px;margin-left: 10px;"
                   size="small">
          <el-option v-for="item in haircutTypeList" :key="item.value" :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </p>
      <p>
        <el-select v-model="query.timeType" style="width: 150px; margin-right: 10px;" size="small">
          <el-option key="0" label="提交时间" value="0">提交时间</el-option>
          <el-option key="1" label="付款时间" value="1">付款时间</el-option>
        </el-select>
        <el-date-picker
          v-model="query.time"
          @change="filterOrder()"
          type="daterange"
          size="small"
          style="margin-left: 10px;margin-right: 25px; width: 250px;"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
        <span style="margin-left: 5px; margin-right: 10px;">支付方式</span>
        <el-select v-model="query.payType" @change="filterOrder()"
                   style="width: 150px;margin-left: 0px;margin-top: 1px;" size="small">
          <el-option v-for="item in payMethodList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <span style="margin-left: 31px; margin-right: 10px;">渠道</span>
        <el-select v-model="query.channel" @change="filterOrder()"
                   style="width: 150px;margin-left: 0px;margin-top: 1px;" size="small">
          <el-option v-for="item in channel" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <span style="margin-left: 31px; margin-right: 10px;">取号属性</span>
        <el-select v-model="query.taskType" @change="filterOrder()"
                   style="width: 150px;margin-left: 0px;margin-top: 1px;" size="small">
          <el-option v-for="item in taskType" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </p>
      <div>
        <span style="margin-right: 10px;">卡金名称</span>
        <el-input type="text" style="width: 200px;margin-right: 20px;" size="small" v-model="query.useCardName"
                  @keydown.enter.native="filterOrder()">
        </el-input>
        <span style=" margin-left: 30px;">
					<el-button size="small" class="buttonStyle01" @click="query.page = 1, filterOrder()">筛选
					</el-button>
					<el-button size="small" class="buttonStyle" @click="reload()">重置</el-button>
					<el-button size="small" class="buttonStyle" @click="expor()" style="margin-left: 20px;">导出订单
					</el-button>
				</span>
      </div>
      <div class="tabelContent" style="margin-top: 20px;">
        <el-table :data="orders" v-loading="loading"
                  :header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
                  style="width: 100%">
          <!-- <el-table-column type="expand">
            <template slot-scope="props">
              <el-form class="demo-table-expand">
                <el-form-item label="商品服务">
                  <span>{{ props.row.type }}</span>
                </el-form-item>
                <el-form-item label="所属店铺">
                  <span>{{ props.row.storeName ?scope.row.storeName :'无' }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column> -->
          <el-table-column prop="id" align="center" label="ID" width="70px"></el-table-column>
          <el-table-column prop="orderNo" align="center" label="订单编号" width="110px">
          </el-table-column>
          <el-table-column label="商品服务" align="center" width="80">
            <template slot-scope="scope">
              {{ scope.row.type == null ? '/' : scope.row.type }}
            </template>
          </el-table-column>
          <el-table-column prop="orderType" align="center" label="订单类型" width="110">
            <template slot-scope="scope">
              {{ scope.row.orderType | typeFormat }}
            </template>
          </el-table-column>
          <el-table-column prop="nickName" align="center" label="用户昵称">
          </el-table-column>
          <el-table-column align="center" label="属性" width="80px">
            <template slot-scope="scope">
              {{
                scope.row.orderType == 11 ? (scope.row.customerType == 3 ? '首次会员' :
                  customerType(scope.row.customerType)) : (scope.row.customerType
                == null ? '/' : customerType(scope.row.customerType))
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="storeType" label="取号属性" width="100">
            <template slot-scope="scope">
              {{ scope.row.taskType == 0 ? '一般取号' : '发型师代取' }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="telphone" label="联系电话" width="115">
          </el-table-column>
          <el-table-column align="center" prop="storeName" label="服务门店" width="100">
            <template slot-scope="scope">
              {{ scope.row.storeName ? scope.row.storeName : '无' }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="storeType" label="门店属性" width="100">
            <template slot-scope="scope">
              {{ scope.row.storeType == 6 ? '加盟店' : '直营店' }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="workerName" label="发型师" width="65">
            <template slot-scope="scope">
              {{ scope.row.workerName ? scope.row.workerName : '无' }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="payType" label="支付方式" width="83">
            <template slot-scope="scope">
              {{ scope.row.payType ? scope.row.payType : '/' }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="total" label="服务价格" width="85">
            <template slot-scope="scope">
              {{
                scope.row.total == null ? scope.row.payTotal == null ? '0' :
                    scope.row.payTotal.toFixed(2)
                  : scope.row.total.toFixed(2)
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="payTotal" label="支付总额" width="85">
            <template slot-scope="scope">
              {{ scope.row.payTotal == null ? '0' : scope.row.payTotal.toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="addTime" label="添加时间" width="100"/>
          <el-table-column align="center" prop="payTime" label="预约时间" width="100">
            <template slot-scope="scope">
              {{ scope.row.subscribeTime ? scope.row.subscribeTime : '/' }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="payTime" label="支付时间" width="100">
            <template slot-scope="scope">
              {{ scope.row.payTime ? scope.row.payTime : '/' }}
            </template>
          </el-table-column>
          <el-table-column label="邀请人" align="center">
            <template slot-scope="scope">
              {{ scope.row.name == null ? '/' : scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="产品类型" width="80px">
            <template slot-scope="scope">
              {{ scope.row.haircutType | haircutTypeFormat }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="服务规格" width="90px">
            <template slot-scope="scope">
              {{ scope.row.serviceSpec ? scope.row.serviceSpec : '/' }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="couponTitle" label="优惠劵">
            <template slot-scope="scope">
              {{ scope.row.couponTitle ? scope.row.couponTitle : '/' }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="couponTitle" label="美团劵" width="70px">
            <template slot-scope="scope">
              {{ scope.row.youzanCode ? scope.row.youzanCode : '/' }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="useCardName" label="卡金名称"
                           width="120px"></el-table-column>
          <el-table-column align="center" prop="useCardLeisureMoney" label="卡金闲时优惠"
                           width="120px"></el-table-column>
          <el-table-column align="center" prop="useCardScore" label="卡金抵扣"></el-table-column>
          <el-table-column align="center" label="渠道" width="70px">
            <template slot-scope="scope">
              {{ scope.row.channel | channelFormat }}
            </template>
          </el-table-column>
          <!--          <el-table-column align="center" label="是否商品订单" width="110px">-->
          <!--            <template slot-scope="scope">-->
          <!--              {{ scope.row.orderPicture ? "是" : "/" }}-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column align="center" label="状态" width="80" fixed="right">
            <template slot-scope="scope">
              {{ statusRemark(scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="85" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="show(scope.row.id,scope.row.couponTitle)">详情 / 编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;">
          <el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
                         style="margin-top: 30px;" layout=" total, prev, pager, next, jumper" :current-page="query.page"
                         :total="query.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  url,
  formatMoney,
  parseTime
} from '../../../utils/index.js'
import {
  download,
  downloadFile
} from '../../../excel/download';
import requestDefault from '../../../excel/download';

export default {
  data() {
    return {
      loading: false,
      url: url(),
      query: {
        page: 1,
        size: 10,
        total: null,
        type: 0,
        text: "",
        addTime: null,
        orderStatus: [],
        orderType: [],
        channel: "",
        payType: "",
        timeType: '0',
        time: [],
        storeId: '',
        useCardName: '',
        taskType: '',
        orderPicture: false
      },
      keys: [{
        label: "订单号",
        value: 1,
      }, {
        label: "剪发订单ID",
        value: 0,
      }, {
        label: "用户昵称/手机号",
        value: 3,
      }, {
        label: "商品名称",
        value: 2,
      },],
      fromList: [{
        label: "全部",
        value: "",
      }, {
        label: "小程序",
        value: "小程序",
      }, {
        label: "H5",
        value: "H5",
      },],
      payMethodList: [{
        label: "全部",
        value: "",
      }, {
        label: "微信支付",
        value: "微信支付",
      }, {
        label: "抖音支付",
        value: "抖音支付",
      }, {
        label: "支付宝支付",
        value: "支付宝支付",
      }, {
        label: "微信支付-现金",
        value: "微信支付-现金",
      }, {
        label: "美团核销码",
        value: "美团核销码",
      }, {
        label: "哈喽支付",
        value: "哈喽支付",
      }, {
        label: "抖音审核",
        value: "抖音审核",
      }, {
        label: "支付宝/给到组合支付",
        value: "支付宝/给到组合支付",
      },],
      orderStateList: [{
        label: "全部",
        value: 100,
      }, {
        label: "排队中",
        value: 0,
      }, {
        label: "服务中",
        value: 1,
      }, {
        label: "待付款",
        value: 2,
      }, {
        label: "已支付",
        value: 3,
      }, {
        label: "已完成",
        value: 5,
      }, {
        label: "已取消",
        value: -1,
      }, {
        label: "部分退款",
        value: -2,
      }, {
        label: "售后订单",
        value: -3,
      }, {
        label: "支付中",
        value: 21,
      }, {
        label: "预约中",
        value: 30,
      },],
      orderTypeList: [{
        label: "全部",
        value: "",
      }, {
        label: "普通订单",
        value: "1",
      }, {
        label: "会员权益订单",
        value: "11",
      }, {
        label: "无限卡订单",
        value: "4",
      }, {
        label: "会员订单",
        value: "6",
      }, {
        label: "会员续费订单",
        value: "7",
      }, {
        label: "次卡订单",
        value: "3",
      }, {
        label: "美团订单",
        value: "9",
      }, {
        label: "企业剪订单",
        value: "2",
      }, {
        label: "染发订单",
        value: "101"
      }, {
        label: "染发次卡订单",
        value: "10",
      }, {
        label: "膨胀券订单",
        value: "5",
      }, {
        label: "卡金充值",
        value: "14",
      }, {
        label: "预约订单",
        value: "20",
      },],
      haircutTypeList: [{
        label: "全部",
        value: "",
      }, {
        label: "剪发",
        value: "0",
      }, {
        label: "烫染",
        value: "1",
      }, {
        label: "洗吹",
        value: "2",
      }, {
        label: "护理",
        value: "3",
      }],
      // time: "",
      orders: [],
      stores: [], //营业门店
      storesEnd: [], //全部门店
      orderData: [{
        total: '',
        wechatTotal: '',
        meituanTotal: '',
        userCount: '',
        memberCount: '',
        memberTotal: '',
        enterprisePayTotal: '',
        haloTotal: ''
      }],
      customerTypeList: [{
        label: "生客",
        value: "0"
      }, {
        label: "熟客",
        value: "1"
      }, {
        label: "深度熟客",
        value: "2"
      }, {
        label: "首次消费",
        value: "3"
      },],
      channel: [{
        label: "全部",
        value: "",
      }, {
        label: "微信",
        value: 1,
      }, {
        label: "抖音",
        value: 2,
      }, {
        label: "美团",
        value: 3,
      }, {
        label: "芭曲",
        value: 4
      }],
      taskType: [{
        label: "全部",
        value: "",
      }, {
        label: "一般取号",
        value: 0,
      }, {
        label: "发型师代取",
        value: 1,
      }],
    };
  },
  computed: {
    statusRemark() {
      return (val) => {
        let result = '';
        this.orderStateList.forEach(ele => {
          if (ele.value == val) result = ele.label;
        });
        return result;
      }
    },
    customerType() {
      return (val) => {
        let result = '';
        this.customerTypeList.forEach(ele => {
          if (ele.value == val) result = ele.label;
        });
        return result;
      }
    },
  },
  filters: {
    typeFormat(val) {
      switch (val) {
        case "1":
          return "普通订单";
        case "3":
          return "次卡订单";
        case "10":
          return "染发次卡订单";
        case "5":
          return "膨胀券订单";
        case "6":
          return "会员订单";
        case "7":
          return "会员续费订单";
        case "9":
          return "美团订单";
        case "2":
          return "企业剪订单";
        case "11":
          return "权益订单";
        case "14":
          return "卡金充值";
        case "20":
          return "预约订单";
        default:
          return "/";
      }
    },
    channelFormat(val) {
      switch (val) {
        case "1":
          return "微信";
        case "2":
          return "抖音";
        case "3":
          return "美团";
        case "4":
          return "芭曲";
        default:
          return "/";
      }
    },
    haircutTypeFormat(val) {
      switch (val) {
        case "0":
          return "剪发项目";
        case "1":
          return "烫染项目";
        case "2":
          return "洗吹项目";
        case "3":
          return "护理项目";
        default:
          return "/";
      }
    }
  },
  created() {
    this.getStores();
  },
  mounted() {
    this.getOrders(1);
    this.getSummary(1);
  },
  methods: {
    show(id, couponTitle) {
      this.$router.push({
        path: "/asshow",
        query: {
          id: id,
          couponTitle: couponTitle
        }
      });
    },
    reload() {
      this.query = {
        page: 1,
        size: 10,
        total: 0,
        type: 0,
        text: "",
        addTime: null,
        orderStatus: [],
        orderType: "",
        channel: "",
        payType: "",
        timeType: '0',
        time: [],
        orderPicture: false,
      };
      this.filterOrder()
    },
    handleCurrentChange(val) {
      this.query.page = val;
      if (this.query.time != null) {
        this.getOrders()
      } else {
        this.getOrders(1)
      }

    },
    handleSizeChange(val) {
      this.query.size = val;
      if (this.query.time != null) {
        this.getOrders()
      } else {
        this.getOrders(1)
      }
    },
    expor() {
      let a = this.requestData()
      // let b = this.toString(a)
      requestDefault({
        method: 'post',
        url: 'dOrder/listDownload',
        data: a,
        headers: {
          'Content_Type': "application/json"
        },
        responseType: 'blob'
      }).then(res => {
        downloadFile(res.data, '订单列表', 'xlsx')
      })
    },
    toString(a) {
      var result = '?page=' + a.page + '&size=' + a.size
      if (a.type != undefined) {
        result += '&type=' + a.type
      }
      if (a.text != undefined) {
        result += '&text=' + a.text
      }
      if (a.startTime != undefined) {
        result += '&startTime=' + a.startTime
      }
      if (a.endTime != undefined) {
        result += '&endTime=' + a.endTime
      }
      if (a.orderStatus != undefined && a.orderStatus != "") {
        result += '&orderStatus=' + a.orderStatus
      }
      if (a.orderType != undefined) {
        result += '&orderType=' + a.orderType
      }
      if (a.haircutType != undefined) {
        result += '&haircutType=' + a.haircutType
      }
      if (a.payType != undefined) {
        result += '&payType=' + a.payType
      }
      if (a.channel != undefined) {
        result += '&channel=' + a.channel
      }
      if (a.orderPicture != undefined) {
        result += '&orderPicture=商品订单'
      }
      if (a.storeId != undefined) {
        result += '&storeId=' + a.storeId
      }
      if (a.timeType != undefined) {
        result += '&timeType=' + a.timeType
      }
      return result
    },
    requestData(t) {
      var arr = {
        page: this.query.page,
        size: this.query.size,
      }
      if (t == 1 || this.query.time[0] == null) {
        arr.startTime = new Date().getFullYear() + '-01-01'
        arr.endTime = new Date().getFullYear() + '-12-31'
      } else {
        if (this.query.time.length > 0) {
          arr.timeType = this.query.timeType
          arr.startTime = this.query.time[0]
          arr.endTime = this.query.time[1]
        }
      }
      if (this.query.orderStatus != null && this.query.orderStatus !== 100) {
        arr.orderStatus = this.query.orderStatus
      }
      if (this.query.orderType !== '') {
        arr.orderType = this.query.orderType
      }
      if (this.query.payType !== '') {
        arr.payType = this.query.payType
      }
      if (this.query.channel !== '') {
        arr.channel = this.query.channel
      }
      if (this.query.haircutType !== '' && this.query.haircutType != null) {
        arr.haircutType = this.query.haircutType
      }
      if (this.query.orderPicture === true) {
        arr.orderPicture = '商品订单'
      }
      if (this.query.storeId !== '') {
        arr.storeId = this.query.storeId
      }
      if (this.query.text !== '') {
        arr.type = this.query.type
        arr.text = this.query.text
      }
      if (this.query.taskType !== '') {
        arr.taskType = this.query.taskType
      }
      if (this.query.useCardName !== '') {
        arr.useCardName = this.query.useCardName
      }
      return arr;
    },

    filterOrder() {
      if (this.query.time != null) {
        this.getOrders();
        this.getSummary();
      } else {
        this.getOrders(1);
        this.getSummary(1);
      }
    },

    getOrders(type) {
      this.loading = true;
      let t = setTimeout(() => { //15秒超时
        this.loading = false
        this.$message.error("请求失败")
      }, 15000)
      var a;
      if (type == 1) {
        a = this.requestData(1)
      } else {
        a = this.requestData()
      }
      this.$http.get("dOrder/list", {
        params: a
      }, {
        emulateJSON: true
      }).then(res => {
        if (res.data.code == 200) {
          this.orders = res.body.data.rows;
          this.query.total = res.body.data.total;
        } else {
          this.$message.error(res.data.msg);
        }
        this.loading = false
        clearTimeout(t)
      })
    },
    //数据概览
    getSummary(type) {
      this.loading = true;
      let t = setTimeout(() => { //15秒超时
        this.loading = false
        this.$message.error("请求失败")
      }, 15000)
      var a;
      if (type == 1) {
        a = this.requestData(1)
      } else {
        a = this.requestData()
      }
      this.$http.get("dOrder/summary", {
        params: a
      }, {
        emulateJSON: true
      }).then(res => {
        if (res.data.code == 200) {
          const a = res.body.data;
          this.orderData[0].total = formatMoney(((a.orderTotal) / 100).toFixed(2))
          this.orderData[0].wechatTotal = formatMoney((a.wechatTotal / 100).toFixed(
            2)) //2023、02、16改为销售额
          this.orderData[0].meituanTotal = a.meituanTotal
          this.orderData[0].memberTotal = formatMoney((a.memberTotal / 100).toFixed(2))
          this.orderData[0].memberDetailTotal = formatMoney((a.memberDetailTotal / 100).toFixed(2))
          this.orderData[0].enterprisePayTotal = formatMoney((a.enterprisePayTotal / 100).toFixed(2))
          this.orderData[0].haloTotal = formatMoney((a.haloTotal / 100).toFixed(2))
          this.orderData[0].timeCardTotal = formatMoney((a.timeCardTotal / 100).toFixed(2))
          this.orderData[0].userCount = formatMoney(a.userCount, 0)
          this.orderData[0].memberCount = formatMoney(a.memberCount, 0)
          this.loading = false
          clearTimeout(t)
          console.log("销毁定时器")
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    getStores() {
      this.$http.get("store/list").then(res => {
        res.body.data.forEach(ele => {
          if (ele.businessType === 1) {
            this.storesEnd.push(ele) //结业门店
          } else {
            this.stores.push(ele) //营业门店
          }
        })
      })
    },
  },
};
</script>

<style lang="less" scoped>
.grid-content {
  border-radius: 4px;
  box-shadow: 2px 2px 3px 2px rgba(102, 102, 102, 0.5);
}

.main-number {
  font-family: SourceHanSansCN-Bold;
  font-size: 22px;
}

.topRight {
  height: 100px;
}

.topRight > div {
  margin-top: 5px;
}

.tableCol {
  border-radius: 4px;
  box-shadow: 2px 2px 3px 2px rgba(102, 102, 102, 0.5);
  margin: 30px -3px 0px -3px;
  padding: 5px 15px 30px 15px;
}

.bg-purple {
  background: #FFFFFF;
}

.main-content {
  padding: 30px 20px 20px 20px;
}

.waiTitel {
  display: flex;
  border-radius: 2px;
}

.green01 {
  height: 14px;
  width: 5px;
  background-color: #4AB52E;
  margin: 5px 0 0 0
}

.topTitle {
  display: flex;
}

.green02 {
  width: 5px;
  height: 5px;
  background: #4AB52E;
  margin: 15px 5px 0 5px
}

.topTitleSmall {
  margin: 5px 0 0 0;
  font-size: 16px;
  font-family: SourceHanSansCN-Bold;
}

.buttonStyle {
  // margin-right: 10px;
  font-family: SourceHanSansCN-Bold;
  background: #FFFFFF !important;
  border-radius: 5px;
  border: 1px solid #CBC9C9;
}

.buttonStyle01 {
  margin-right: 10px;
  font-family: SourceHanSansCN-Bold;
  color: #FFFFFF;
  background: #4AB52E !important;
  border-radius: 5px;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4AB52E;
  border-radius: 5px;
  color: #FFF;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #4AB52E;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
  border-radius: 5px;
}

/deep/ .el-icon-arrow-down:before {
  content: "\e6d1";

}

/deep/ .el-select-dropdown__item {
  width: 220px;
}
</style>
